class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn || this, focusElement || containerToTrapFocusOn);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active', 'animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    $('cart-drawer.drawer').removeClass('active');
    // Force reflow so mobile browsers clear the overlay (fixes stuck haze)
    this.offsetHeight;
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const sections = parsedState && parsedState.sections;
    if (!sections || typeof sections !== 'object') {
      if (parsedState && parsedState.id) this.productId = parsedState.id;
      this.open();
      return;
    }
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner && drawerInner.classList.contains('is-empty')) drawerInner.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const html = sections[section.id];
      if (html == null) return;
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      try {
        sectionElement.innerHTML = this.getSectionInnerHTML(html, section.selector);
      } catch (e) {}
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      document.dispatchEvent(new CustomEvent('cart-drawer:content-updated'));
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Method to handle AJAX add to cart from collection pages
  addToCartAjax(variantId) {
    // Use the same approach as product-form.js
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', this.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    
    config.body = formData;

    return fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status || response.error) {
          throw new Error(response.description || response.message || response.error || 'Could not add to cart');
        }
        this.renderContents(response);
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart: ' + (error.message || 'Please try again.'));
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

// Function to show notification
function showNotification() {
  const notification = document.getElementById('notification-box');
  if (notification) {
    notification.classList.add('show');
    
    // Auto-hide after 5 seconds
    setTimeout(() => {
      closeNotification();
    }, 5000);
  }
}

// Function to close notification
function closeNotification() {
  const notification = document.getElementById('notification-box');
  if (notification) {
    notification.classList.remove('show');
  }
}

/**
 * Function check validate checkbox agree cart drawer
 */
$(document).ready(function() {
    if ($('.agree-drawer-footer-checkbox').length > 0) {
      $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        if ($('#agree').is(':checked')) {
          $(this).submit();
        }
        else {
          // Show notification if checkbox is not checked
          if (typeof showNotification === 'function') {
            showNotification();
          }
          return false;
        }
      });
    }
});

